module.exports = __webpack_public_path__ + "img/debut-stream-pfp.6b53a0f5.webp";